import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Injectable, Injector} from '@angular/core';
import { LocalStorage } from '../utils/local-storage.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  private localStorage: LocalStorage;

  constructor(private injector: Injector) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.localStorage = this.injector.get(LocalStorage);
    const idToken = this.localStorage.getItem('id_token');
    const url = req.url.toString();

    if (this.isValidPath(url)) {
      req = req.clone({
        setHeaders: {
          'Authorization': `${idToken}`
        }
      });
    }

    return next.handle(req);
  }

  isValidPath(path: string): boolean {
    const paths = [
      '/regions',
      '/cities',
      '/nationalities',
      '/refresh-token',
      '/logout',
      '/accounts/change-password',
      '/accounts/user-profile',
      '/accounts/document',
      '/application-form',
      '/upload-attachment',
      '/application-form/download-attachment',
      '/**'
    ];

    return paths.filter(p => path.includes(p)).length > 0;
  }

}
